export const testimonials = [
  {
    testimonial:
      'An amazing adventure with Dorze Tours! From the vibrant markets of Addis Ababa to the majestic landscapes of the Simien Mountains, every moment was unforgettable.',
    name: 'Emily L.',
    location: 'London, UK',
  },
  {
    testimonial:
      'Exceptional service from Dorze Tours! Our trip to Ethiopia was seamless, with knowledgeable guides and stunning sights at every turn.',
    name: 'Michael S.',
    location: 'Sydney, Australia',
  },
  {
    testimonial:
      'A dream come true! Thanks to Dorze Tours, we explored the wonders of Ethiopia hassle-free. Highly recommend!',
    name: 'Lisa M',
    location: 'Toronto, Canada',
  },
  {
    testimonial:
      'Incredible experience with Dorze Tours! From the historic sites of Gondar to the breathtaking beauty of the Omo Valley, we were in awe every step of the way.',
    name: 'Sarah W.',
    location: ' Los Angeles, USA',
  },
  {
    testimonial:
      'Absolutely loved our tour with Dorze Tours! The guides were fantastic, the accommodations were top-notch, and the memories we made will last a lifetime.',
    name: 'Rachel H.',
    location: 'Auckland, New Zealand',
  },
  {
    testimonial:
      'An amazing adventure with Dorze Tours! From the vibrant markets of Addis Ababa to the majestic landscapes of the Simien Mountains, every moment was unforgettable.',
    name: 'Emily L.',
    location: 'London, UK',
  },
];
